import React from "react";
import { DetailsPopup } from "modules/common/components/form/DetailsPopup";
import { Block } from "modules/common/components/page/Block";
import { RouteComponentProps, withRouter } from "modules/common/components/routing/withRouter";
import { matchRoute } from "modules/common/services/routing";
import { WhenPath } from "modules/common/components/routing/WhenPath";
import { routes } from "modules/common/routes";
import { UnregisterCallback } from "modules/common/components/routing/withRouter";
import { observer } from "mobx-react";
import { texts } from "modules/common/texts";
import { EMPTY_OBJECT_ID } from "modules/common/constants";
import { OverheadTypesStoreType } from "../models/overhead-types-store";
import { OverheadTypeDetails } from "./details/OverheadTypeDetails";
import { OverheadTypesList } from "./list/OverheadTypesList";
import { menuItems } from "modules/root/components/menu/MainMenu";
import func from "modules/dictionaries/functionalities";
import { can } from "modules/session/auth/access";
import styles from "./OverheadTypesPage.module.scss";
import { PlanrButton } from "modules/common/components/planr/button/Button";
import { Search } from "modules/common/components/form/Search";

const menu = menuItems();

class OverheadTypesPage extends React.Component<OverheadTypesPageProps & RouteComponentProps, OverheadTypesPageState> {
  private unregister: UnregisterCallback | null = null;

  constructor(props: OverheadTypesPageProps & RouteComponentProps) {
    super(props);

    this.state = { typeId: getSelectedOverheadTypeId(props.location.pathname) };
  }

  componentDidMount() {
    document.title = menu.dictionaries.nested.overheadType.label;

    const { history } = this.props;
    const { typeId } = this.state;

    this.loadList();
    this.loadDetails(typeId);

    this.unregister = history.listen((location) => {
      const tId = getSelectedOverheadTypeId(location.pathname);

      if (this.state.typeId !== tId) {
        this.setState({ typeId: tId });
        this.loadDetails(tId);
      }
    });
  }

  componentWillUnmount() {
    this.unregister && this.unregister();
  }

  render() {
    const { store, access } = this.props;
    const canChange = can(func.OVERHEADTPYE_EDIT, access);

    return (
      <Block columned={true} className={styles.page}>
        <WhenPath path={routes.dictionaries.overheadType.details()}>
          <DetailsPopup title="Тип накладного расхода" onCancel={this.onOverheadTypeSelected}>
            <OverheadTypeDetails
              canChange={canChange}
              overheadType={store.details}
              onSaved={this.onOverheadTypeSaved}
              onRemoved={this.onOverheadTypeRemoved}
            />
          </DetailsPopup>
        </WhenPath>
        {canChange && (
          <PlanrButton
            type="secondary"
            size="small"
            icon="general-plus-big"
            onClick={this.onOverheadTypeAdd}
            style={{
              width: "320px",
              marginBottom: "32px",
              borderRadius: "120px",
            }}
          >{`${texts.add} вид накладного расхода`}</PlanrButton>
          // <DictioantyAddButton onClick={this.onOverheadTypeAdd} label={`${texts.add} тип накладного расхода`} />
        )}
        <div className={styles.right}>
          <Search query={store.list.query} onSearch={store.list.setQuery} />
        </div>
        <OverheadTypesList
          store={store.list}
          onSelected={this.onOverheadTypeSelected}
          onRemoved={this.onOverheadTypeRemoved}
        />
      </Block>
    );
  }

  onOverheadTypeAdd = () => {
    this.onOverheadTypeSelected(EMPTY_OBJECT_ID);
  };

  onOverheadTypeSelected = (id: string = "") => {
    const { history } = this.props;

    const url = id ? routes.dictionaries.overheadType.details(id) : routes.dictionaries.overheadType.path;

    history.push(url);
  };

  onOverheadTypeSaved = () => {
    this.onOverheadTypeSelected("");
    this.loadList();
  };

  onOverheadTypeRemoved = () => {
    const { history } = this.props;

    this.loadList();

    const url = routes.dictionaries.overheadType.path;
    history.push(url);
  };

  loadList = () => this.props.store.list.load();

  loadDetails = (id: string) => this.props.store.details.load(id);
}

export default withRouter(observer(OverheadTypesPage));

function getSelectedOverheadTypeId(pathname: string) {
  const match = matchRoute<OverheadTypesPageState>(pathname, routes.dictionaries.overheadType.details());

  return match && match.params ? match.params.typeId : "";
}

interface OverheadTypesPageProps {
  store: OverheadTypesStoreType;
  access: string[];
}

interface OverheadTypesPageState {
  typeId: string;
}
